import React from 'react';

const ReicoExpressFilter = ({ handleChange, isEnabled, isActive }) => {
  return (
    <div className="reico-express checkbox">
      <label>
        <input 
            type="checkbox"
            id="filter-reico-express"
            onChange={() => handleChange()}
            disabled={!isEnabled}
            checked={isActive}
        /> Show Only Reico Express
      </label>
    </div>
  );
};

export default ReicoExpressFilter;